export default __webpack_public_path__ + "static/media/people8full.b916b503.jpg";